import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/AdPage.css';
import NativeBanner from '../components/NativeBanner';

const AdPage1 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [countdown, setCountdown] = useState(8);
  const [canProceed, setCanProceed] = useState(false);

  const searchParams = new URLSearchParams(location.search);
  const postId = searchParams.get('go');

  useEffect(() => {
    if (!postId) {
      navigate('/');
      return;
    }

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          setCanProceed(true);
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [postId, navigate]);

  const handleContinue = () => {
    if (canProceed) {
      const hasClickedOnce = sessionStorage.getItem(`clicked_ad1_${postId}`);
      if (!hasClickedOnce) {
        sessionStorage.setItem(`clicked_ad1_${postId}`, 'true');
        window.open('https://www.profitableratecpmnetwork.com/p30hpe5v?key=308e8f6fbe3fe7839661a714c9301acf', '_blank');
        window.location.reload();
      } else {
        sessionStorage.removeItem(`clicked_ad1_${postId}`);
        window.location.href = `/link2?go=${postId}`;
      }
    }
  };

  return (
    <div className="ad-page-container">
      <div className="ad-page-content">
        <div className="ad-page-card">
          <h1>ခဏလေးစောင့်ပါ</h1>
          {!canProceed ? (
            <p className="ad-page-subtitle">စာဖတ်ရန် ပြင်ဆင်နေပါသည်...</p>
          ) : (
            <p className='ad-page-subtitle'>"ဆက်သွားရန်" ကို နှိပ်ပါ</p>
          )}

          {!canProceed ? (
            <div className="countdown-section">
              <div className="countdown-circle">
                <span className="countdown-number">{countdown}</span>
              </div>
              <p className="countdown-text">{countdown} စက္ကန့် စောင့်ပေးပါ...</p>
            </div>
          ) : (
            <button
              onClick={handleContinue}
              className="continue-button pulse"
              style={{ backgroundColor: '#28a745', padding: '15px 40px' }}
            >
              ဆက်သွားရန် နှိပ်ပါ →
            </button>
          )}

          <div className="large-ad-space">
            <NativeBanner />
          </div>

          <div className="side-ad-space">
            <NativeBanner />
          </div>
        </div>
      </div>

      <NativeBanner />
    </div>
  );
};

export default AdPage1;
